const state = {
  navShow: false,
  isShow: false,
  imgUrl: ''
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js